import React, { Component, Fragment } from "react";
import { properties } from "../../constants/Propertise";
import { api } from "../../api/api";
import Overlay from "../Overlay";
import validator from "validator";
import { Input } from "reactstrap";
import InlineError from "../InlineError";
import ForgetPasswordOTPandResetPassword from "./ForgetPasswordOTPandResetPassword";

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      userDetails: {
        username: "",
      },
      showOtpPopup: false,
      userInformation: [],
      showPending: false,
      showError: false,

      //test//
      showEntreNewPassword: false,
    };
  }

  handleChange = (event) => {
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        [event.target.name]: event.target.value,
      },
      errors: {},
    });
  };

  validate = (data) => {
    const errors = {};
    if (!data.username) {
      errors.username = properties.userNameRequired;
    } else if (!validator.isEmail(data.username)) {
      errors.username = properties.validUserNameEmailRequired;
    }

    return errors;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const formData = {
      username: this.state.userDetails.username.trim(),
    };

    const errors = this.validate(formData);
    this.setState({ errors }, () => {
      if (Object.keys(errors).length === 0) {
        this.setState({
          showPending: true,
        });
        this.validateUserName(formData);
      }
    });
  };

  validateUserName = (forgetPasswordData) => {
    let validateUserUrl =
      process.env.REACT_APP_API_URL +
      "forgotPassword/verifyUserExistenceAndEmailOTP";
    api
      .post(validateUserUrl, forgetPasswordData)
      .then((validateUserResult) => {
        if (validateUserResult.data !== undefined) {
          if (validateUserResult.status === 200) {
            console.log(validateUserResult.data);
            if (validateUserResult.data === "User Does Not Exist") {
              const errors = {};
              errors.username = validateUserResult.data;
              this.setState({
                showPending: false,
                showError: false,
                showOtpPopup: false,
                errors: errors,
              });
            } else if (validateUserResult.data === "") {
              this.setState({
                showError: true,
                showOtpPopup: false,
                showPending: false,
              });
            } else if (
              validateUserResult.data ===
              "User-Existence Verified!, OTP Request Limit Exceeded, Please Contact Admin (Limit: 3 Times)"
            ) {
              const errors = {};
              errors.username = validateUserResult.data;
              this.setState({
                showPending: false,
                showError: false,
                showOtpPopup: false,
                errors: errors,
              });
            } else {
              this.setState({
                showPending: false,
                showError: false,
                showOtpPopup: true,
                userInformation: validateUserResult.data,
                showEntreNewPassword: true,
              });
            }
          }
        } else {
          this.setState({
            showError: true,
            showOtpPopup: false,
            showPending: false,
          });
        }
      })
      .catch((validateUserError) => {
        this.setState({
          showError: true,
          showOtpPopup: false,
          showPending: false,
        });
      });
  };

  closeOtpPopup = () => {
    this.props.closePopup();
    this.setState({
      showOtpPopup: false,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    // if (prevState.errors.username !== this.state.errors.username) {
    //   if (this.state.errors.username) {
    //     setTimeout(() => {
    //       this.setState({
    //         userDetails: {
    //           username: "",
    //         },
    //         errors: {},
    //       });
    //     }, 1000);
    //   }
    // }
  }

  //test//
  closeEntreNewPasswordPopup = () => {
    this.setState({
      showEntreNewPassword: false,
    });
  };

  render() {
    return (
      <Fragment>
        <div className="mb-3">
          <Overlay
            title={properties.forgetPassText}
            openOverlay={this.state.showEntreNewPassword}
            closeOverlay={this.closeEntreNewPasswordPopup}
          >
            <ForgetPasswordOTPandResetPassword
              username={this.state.userDetails.username}
              closeForgotPasswordOTPPopup={this.closeEntreNewPasswordPopup}
            />
          </Overlay>

          {this.state.showPending === true && (
            <div className="form-row">
              <div className="col-md-12 mb-3">
                <div
                  className="alert alert-info alert-dismissible"
                  role="alert"
                  style={{ textAlign: "center" }}
                >
                  {properties.pleaseWaitText}
                </div>
              </div>
            </div>
          )}
          {this.state.showError === true && (
            <div className="form-row">
              <div className="col-md-12 mb-3">
                <div
                  className="alert alert-danger alert-dismissible"
                  role="alert"
                  style={{ textAlign: "center" }}
                >
                  {properties.globalUserErrorMessage}
                </div>
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="col-md-12 mb-3">
              {properties.forgotPasswordHeaderText}
            </div>
          </div>

          <form onSubmit={this.handleSubmit.bind(this)} autoComplete="off">
            <div className="form-row">
              <div className="col-md-12 mb-3">
                <label className="feildName">
                  {properties.userNameText}
                  <span className="required">*</span>:
                </label>
                <Input
                  type="text"
                  name="username"
                  value={this.state.userDetails.username}
                  onChange={this.handleChange.bind(this)}
                  maxLength={properties.titleMaxCharLength}
                  valid={
                    this.state.errors.username === undefined &&
                    this.state.userDetails.username !== "" &&
                    this.state.isValid === true
                      ? true
                      : false
                  }
                  invalid={
                    this.state.errors.username !== undefined ? true : false
                  }
                />
                {this.state.errors.username && (
                  <InlineError text={this.state.errors.username} />
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="divider" />
        <div className="mb-3">
          <button
            className="btn btn-primary pull-right"
            type="submit"
            onClick={this.handleSubmit}
          >
            {properties.submitButtonText}
          </button>
        </div>
      </Fragment>
    );
  }
}

export default ForgetPassword;
